import { render } from "./TmsIntakeBanner.vue?vue&type=template&id=c9dacedc&scoped=true"
import script from "./TmsIntakeBanner.vue?vue&type=script&lang=js"
export * from "./TmsIntakeBanner.vue?vue&type=script&lang=js"

import "./TmsIntakeBanner.vue?vue&type=style&index=0&id=c9dacedc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9dacedc"]])

export default __exports__